export const navLink = "robots_history";
export const name = "История роботов";
